import * as React from 'react'

import { Box, Router, Table } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import type { DashboardAuthorInfo } from 'modules/reports/lib/types'
import type Dashboard from 'modules/reports/store/models/Dashboard'

import Body from './_Body'
import Header from './_Header'
import SearchBar from './_SearchBar'

interface Props {
  dashboards: Dashboard[]
  filtersForm: Form
  showAddDashboardButton: boolean
  canManageReports: boolean
  authorsByDashboardId: Map<string, DashboardAuthorInfo>
}

const useFilter = createComputed((dashboards: Dashboard[], search: string) => {
  const searchDashboards = dashboards.filter((dashboard) =>
    matchText(search, dashboard.attributes.title)
  )

  return searchDashboards
})

const ListDashboards = ({
  dashboards,
  filtersForm,
  showAddDashboardButton,
  canManageReports,
  authorsByDashboardId,
}: Props) => {
  const { navigation } = useNavigation()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const filteredDashboards = useFilter(dashboards, debouncedSearch).get()

  return (
    <Box>
      <Box flexDirection="row" alignItems="center" gap="s12" paddingY="s24">
        <SearchBar search={search} onSearch={onSearch} />
        {showAddDashboardButton && (
          <Router iconName="add" to={navigation.reports.dashboards.list.new.fullPath()}>
            {i18n.t('custom_reports.add_dashboard')}
          </Router>
        )}
      </Box>

      <Box>
        <Table autoLayout fullWidth>
          <Header filtersForm={filtersForm} />
          <Body
            dashboards={filteredDashboards}
            canManageReports={canManageReports}
            authorsByDashboardId={authorsByDashboardId}
          />
        </Table>
      </Box>
    </Box>
  )
}

export default observer(ListDashboards)
